import { TubeStation } from "../types";

export const tubeStations: TubeStation[] = [
  { naptan: "940GZZLUVXL", name: "Vauxhall Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUSPU",
    name: "St. Paul's Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUMPK",
    name: "Moor Park Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUQPS",
    name: "Queen's Park Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUBLR",
    name: "Blackhorse Road Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUHSC",
    name: "Hammersmith Stn / H&C and Circle Lines",
    mode: "tube",
  },
  {
    naptan: "940GZZLUCGN",
    name: "Covent Garden Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUPNR", name: "Pinner Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUESQ",
    name: "Euston Square Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUBTK",
    name: "Burnt Oak Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUHSK",
    name: "High Street Kensington Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSJP",
    name: "St. James's Park Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUCST",
    name: "Cannon Street Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUUPM",
    name: "Upminster Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLURBG",
    name: "Redbridge Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSKT",
    name: "South Kenton Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUKBN", name: "Kilburn Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUPCC",
    name: "Piccadilly Circus Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLURVP",
    name: "Ravenscourt Park Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUBLM", name: "Balham Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUDGY",
    name: "Dagenham Heathway Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUNGW",
    name: "North Greenwich Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUMDN", name: "Morden Underground Station", mode: "tube" },
  {
    naptan: "940GZZLURVY",
    name: "Roding Valley Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUTBC",
    name: "Tooting Bec Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUWKA",
    name: "Warwick Avenue Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUCHL",
    name: "Chancery Lane Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUHNX",
    name: "Hatton Cross Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSJW",
    name: "St John's Wood Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUCTN",
    name: "Camden Town Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUHOH",
    name: "Harrow-on-the-Hill Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUMYB",
    name: "Marylebone Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUCWR",
    name: "Canada Water Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLURSP", name: "Ruislip Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUSFB",
    name: "Stamford Brook Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUCGT",
    name: "Canning Town Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUECM",
    name: "Ealing Common Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUPAH",
    name: "Paddington (H&C Line)-Underground",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSBM",
    name: "Shepherd's Bush Market Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUMSH",
    name: "Mansion House Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUTBY",
    name: "Tooting Broadway Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUPLW", name: "Plaistow Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUKSX",
    name: "King's Cross St.Pancras Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSKS",
    name: "South Kensington Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSFS",
    name: "Southfields Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUBWT",
    name: "Bayswater Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLURKW",
    name: "Rickmansworth Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUNHA",
    name: "North Harrow Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUKNG",
    name: "Kennington Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUWLO", name: "Waterloo Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUWYC",
    name: "Wembley Central Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUWIG",
    name: "Willesden Green Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSWK",
    name: "Southwark Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUASG",
    name: "Arnos Grove Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUGPK",
    name: "Green Park Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUHWC",
    name: "Hounslow Central Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUKSX",
    name: "King's Cross St. Pancras Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUNAN",
    name: "North Acton Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUHGT", name: "Highgate Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUTPN",
    name: "Turnpike Lane Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUFYR",
    name: "Finchley Road Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUFCN",
    name: "Farringdon Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLULGN", name: "Loughton Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUNFD",
    name: "Northfields Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSGP",
    name: "Stonebridge Park Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUTHB",
    name: "Theydon Bois Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUCAR",
    name: "Caledonian Road Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUEAN",
    name: "East Acton Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUWOF", name: "Woodford Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUEFY",
    name: "East Finchley Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUEUS", name: "Euston Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUHCL",
    name: "Hendon Central Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUWSM",
    name: "Westminster Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUEAE", name: "Eastcote Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUCYD",
    name: "Chorleywood Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUBST",
    name: "Baker Street Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUHAW",
    name: "Harrow & Wealdstone Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUGBY",
    name: "Gunnersbury Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUERB",
    name: "Edgware Road (Bakerloo Line) Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUEGW", name: "Edgware Underground Station", mode: "tube" },
  { naptan: "940GZZLUEPK", name: "Elm Park Underground Station", mode: "tube" },
  {
    naptan: "940GZZLURYL",
    name: "Rayners Lane Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLURSQ",
    name: "Russell Square Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUWLA",
    name: "Wood Lane Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUCPC",
    name: "Clapham Common Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUMTC",
    name: "Mornington Crescent Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSVS",
    name: "Seven Sisters Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUKPK",
    name: "Kilburn Park Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSWN",
    name: "South Wimbledon Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUPAC",
    name: "Paddington Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUOSY", name: "Osterley Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUWFN",
    name: "West Finchley Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUEPG", name: "Epping Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUSWC",
    name: "Swiss Cottage Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSUT",
    name: "Sudbury Town Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUGGN",
    name: "Golders Green Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUNDN", name: "Neasden Underground Station", mode: "tube" },
  { naptan: "940GZZLUMMT", name: "Monument Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUCFM",
    name: "Chalk Farm Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUWBN",
    name: "West Brompton Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUHGD",
    name: "Hillingdon Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUFBY",
    name: "Fulham Broadway Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUCYF",
    name: "Canary Wharf Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUBKG", name: "Barking Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUBLG",
    name: "Bethnal Green Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUALP", name: "Alperton Underground Station", mode: "tube" },
  {
    naptan: "940GZZLULRD",
    name: "Latimer Road Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUTMH",
    name: "Tottenham Hale Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUKNB",
    name: "Knightsbridge Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUWJN",
    name: "Willesden Junction Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUWKN",
    name: "West Kensington Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUDGE",
    name: "Dagenham East Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUEPY",
    name: "East Putney Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUHWY",
    name: "Holloway Road Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUKSH",
    name: "Kentish Town Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLULNB",
    name: "London Bridge Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLURSM",
    name: "Ruislip Manor Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUHRC",
    name: "Heathrow Terminals 2 & 3 Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSBC",
    name: "Shepherd's Bush (Central Line) Underground Stn",
    mode: "tube",
  },
  {
    naptan: "940GZZLUODS",
    name: "Old Street Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUTCR",
    name: "Tottenham Court Road Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLULAD",
    name: "Ladbroke Grove Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUWIM",
    name: "Wimbledon Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUGTR",
    name: "Gloucester Road Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUHR5",
    name: "Heathrow Terminal 5 Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUBKE",
    name: "Barkingside Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUNWH",
    name: "Northwood Hills Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUBBB",
    name: "Bromley-By-Bow Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUHPK",
    name: "Holland Park Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUWWL",
    name: "Walthamstow Central Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUWSP",
    name: "Westbourne Park Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUMED", name: "Mile End Underground Station", mode: "tube" },
  { naptan: "940GZZLUWAF", name: "Watford Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUCND",
    name: "Colindale Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUACY", name: "Archway Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUKBY",
    name: "Kingsbury Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUTMP", name: "Temple Underground Station", mode: "tube" },
  {
    naptan: "940GZZLURGP",
    name: "Regent's Park Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUOVL", name: "Oval Underground Station", mode: "tube" },
  { naptan: "940GZZLUAGL", name: "Angel Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUGPS",
    name: "Great Portland Street Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUERB",
    name: "Edgware Road (Bakerloo) Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUNBP",
    name: "Newbury Park Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLURMD", name: "Richmond Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUHAI",
    name: "Highbury & Islington Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSGT",
    name: "Southgate Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUHTD",
    name: "Hampstead Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUWTA",
    name: "West Acton Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUNWY",
    name: "North Wembley Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSKW",
    name: "Stockwell Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLURYO",
    name: "Royal Oak Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSJW",
    name: "St. John's Wood Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUTNG",
    name: "Turnham Green Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUWOP",
    name: "Woodside Park Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUMHL",
    name: "Mill Hill East Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUGTH",
    name: "Gants Hill Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSGN",
    name: "Stepney Green Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUPRD",
    name: "Preston Road Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUOXC",
    name: "Oxford Circus Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUBMY",
    name: "Bermondsey Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUGFD",
    name: "Greenford Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUMBA",
    name: "Marble Arch Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUHLT", name: "Hainault Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUBBB",
    name: "Bromley-by-Bow Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLULVT",
    name: "Liverpool Street Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSWF",
    name: "South Woodford Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUUPK",
    name: "Upton Park Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUBWR", name: "Bow Road Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUEAC",
    name: "Elephant & Castle Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUHGR",
    name: "Hanger Lane Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUWCY",
    name: "White City Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUPVL", name: "Perivale Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUFPK",
    name: "Finsbury Park Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUKOY",
    name: "Kensington (Olympia) Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUHSC",
    name: "Hammersmith (H&C Line) Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLULBN",
    name: "Lambeth North Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUWIG", name: "Willesden Green Station", mode: "tube" },
  {
    naptan: "940GZZLUPYB",
    name: "Putney Bridge Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUMGT", name: "Moorgate Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUHCH",
    name: "Hornchurch Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUBNK", name: "Bank Underground Station", mode: "tube" },
  { naptan: "940GZZLUHBN", name: "Holborn Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUCPK",
    name: "Canons Park Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUTFP",
    name: "Tufnell Park Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUBEC",
    name: "Becontree Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUGGH",
    name: "Grange Hill Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUNHG",
    name: "Notting Hill Gate Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUBXN", name: "Brixton Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUBZP",
    name: "Belsize Park Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUECT",
    name: "Earl's Court Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUHWT",
    name: "Hounslow West Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUKEN", name: "Kenton Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUEBY",
    name: "Ealing Broadway Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLULYS",
    name: "Leytonstone Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUEMB",
    name: "Embankment Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUBKF",
    name: "Blackfriars Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSSQ",
    name: "Sloane Square Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUGDG",
    name: "Goodge Street Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSUH",
    name: "Sudbury Hill Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUWYP",
    name: "Wembley Park Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUICK", name: "Ickenham Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUHWE",
    name: "Hounslow East Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLULSQ",
    name: "Leicester Square Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUOAK", name: "Oakwood Underground Station", mode: "tube" },
  { naptan: "940GZZLUCWL", name: "Chigwell Underground Station", mode: "tube" },
  {
    naptan: "940GZZLULGT",
    name: "Lancaster Gate Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSRP",
    name: "South Ruislip Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUNEN",
    name: "North Ealing Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUALD", name: "Aldgate Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUQBY",
    name: "Queensbury Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUUPB",
    name: "Upminster Bridge Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUFLP", name: "Fairlop Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUBKH",
    name: "Buckhurst Hill Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUFYC",
    name: "Finchley Central Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSHH",
    name: "South Harrow Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUVIC", name: "Victoria Underground Station", mode: "tube" },
  { naptan: "940GZZLUWHP", name: "West Hampstead Station", mode: "tube" },
  {
    naptan: "940GZZLUWHW",
    name: "West Harrow Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLURSG",
    name: "Ruislip Gardens Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUNOW",
    name: "Northwood Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUUPY", name: "Upney Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUHRC",
    name: "Heathrow Terminals 1-2-3 Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUSTM", name: "Stanmore Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUWRP",
    name: "West Ruislip Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUBND",
    name: "Bond Street Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUCPS",
    name: "Clapham South Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUUXB", name: "Uxbridge Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUQWY",
    name: "Queensway Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUTAW",
    name: "Totteridge & Whetstone Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUWOG",
    name: "Wood Green Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUWPL",
    name: "Whitechapel Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUPKR",
    name: "Park Royal Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSBC",
    name: "Shepherd's Bush (Central) Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUBBN", name: "Barbican Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUHBT",
    name: "High Barnet Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUKSL",
    name: "Kensal Green Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUNKP",
    name: "Northwick Park Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUKWG",
    name: "Kew Gardens Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUTWH",
    name: "Tower Hill Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUAMS", name: "Amersham Underground Station", mode: "tube" },
  { naptan: "940GZZLUDBN", name: "Debden Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUACT",
    name: "Acton Town Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUPCO", name: "Pimlico Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUMRH",
    name: "Manor House Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUASL", name: "Arsenal Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUPAH",
    name: "Paddington (H&C Line) Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUERC",
    name: "Edgware Road (Circle Line) Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUCPN",
    name: "Clapham North Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUBOR", name: "Borough Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUCAL",
    name: "Chalfont & Latimer Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUHR4",
    name: "Heathrow Terminal 4 Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLULYN", name: "Leyton Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUWRR",
    name: "Warren Street Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUCSD",
    name: "Colliers Wood Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUWIP",
    name: "Wimbledon Park Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUPSG",
    name: "Parsons Green Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSTD",
    name: "Stratford Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUCSM", name: "Chesham Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUCWP",
    name: "Chiswick Park Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUDOH",
    name: "Dollis Hill Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUBSC",
    name: "Barons Court Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUCKS",
    name: "Cockfosters Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUWHM", name: "West Ham Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUBDS",
    name: "Bounds Green Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUADE",
    name: "Aldgate East Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUBOS",
    name: "Boston Manor Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUGHK",
    name: "Goldhawk Road Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUHSN",
    name: "Harlesden Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSEA",
    name: "South Ealing Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUSNB",
    name: "Snaresbrook Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUWSD", name: "Wanstead Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUBTX",
    name: "Brent Cross Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUCXY", name: "Croxley Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUCHX",
    name: "Charing Cross Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUEHM", name: "East Ham Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUHSD",
    name: "Hammersmith (Dist&Picc Line) Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUHPC",
    name: "Hyde Park Corner Underground Station",
    mode: "tube",
  },
  {
    naptan: "940GZZLUMVL",
    name: "Maida Vale Underground Station",
    mode: "tube",
  },
  { naptan: "940GZZLUNHT", name: "Northolt Underground Station", mode: "tube" },
  {
    naptan: "940GZZLUWHP",
    name: "West Hampstead Underground Station",
    mode: "tube",
  },
];
